import { mutateWithErrorHandling } from '@module/mdrt-org/shared/utils/http-services/mutate-with-error-handling';

export const postEmailWithPressReleasePdf = async ({
  emailBody,
  emailSubject,
  encodedPdf,
  fileName,
  recipientEmail,
  recipientName,
}: {
  emailBody: string;
  emailSubject: string;
  encodedPdf: string;
  fileName: string;
  recipientEmail: string;
  recipientName: string;
}) => {
  return await mutateWithErrorHandling(`/api/sendgrid/press-release`, {
    body: JSON.stringify({
      emailBody,
      emailSubject,
      encodedPdf,
      fileName,
      recipientEmail,
      recipientName,
    }),
    method: 'POST',
  });
};
